import qs from 'qs';
import { client } from '@/client';

// 获取topic概览
export function getTopicOverview(clusterName) {
  return client.get(`/api/console/kop/topic/${clusterName}/overview`);
}

// topic列表服务端
export function getTopicListServerPaginate(params) {
  return client.post(`/api/console/kop/topic/list`, params);
}

// 获取所有namespace
export async function getNamespacesOptions(params) {
  const { data } = await client.get('/api/console/kop/security/getAllNamespaces', params);
  return data.map((item) => ({
    label: item,
    value: item,
  }));
}

// 批量删除Topic
export function delTopicBatch(params) {
  return client.delete('/api/resource/kop/topic/batchDelete', params);
}

// 图表接口
export function getTopicChartData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/kop/topic/${clusterName}`, others);
}

// 图表接口-分区
export function getTopicPartitionChartData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/kop/topic/partition/${clusterName}`, others);
}

// 单个topic总览
export function getTopicDetailOverView(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/console/kop/topic/${clusterName}`, others);
}

// 删除Topic
export function delTopic(params) {
  return client.delete('/api/resource/kop/topic/delete', params);
}

// 获取topic分区列表
export function getTopicPartitionList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/console/kop/topic/partition/${clusterName}`, others);
}

// 获取消息列表
export function getMessageList(params) {
  return client.get(`/api/resource/kop/topic/getMessage`, params);
}

// 获取topic配置
export function getTopicConfig(params) {
  return client.get(`/api/resource/kop/topic/config/list`, params);
}

// 更新topic配置
export function updateTopicConfig(params) {
  return client.put(
    `/api/resource/kop/topic/config/update${qs.stringify(params, { addQueryPrefix: true })}`,
    params,
  );
}

// 更新分区扩容
export function updatePartitionNum(params) {
  return client.put(
    `/api/resource/kop/topic/increasePartitions${qs.stringify(params, { addQueryPrefix: true })}`,
    params,
  );
}

// 创建topic
export function createTopic(params) {
  return client.put('/api/resource/kop/topic/create', params);
}
